<template>
  <div class="relative metric-card">
    <StatCard
      :title="title"
      :content-str="contentStr"
      :card-type="cardType"
      :sub-content-str="subContentStr"
      :loader="loader"
      :is-plus="isPlus"
    />
    <i
      v-if="info"
      v-tooltip.top="info"
      class="pi pi-info-circle absolute cursor-help text-bluegray-400"
      style="top: 0.85rem; right: 0.85rem; font-size: 0.75rem"
    />
  </div>
</template>

<script>
import StatCard from "@/components/AdminNewDashboard/AdminNewDashboardComponents/StatCard.vue";

export default {
  name: "MetricCard",
  components: { StatCard },
  props: {
    title: { type: String, default: "" },
    contentStr: { type: String, default: "" },
    cardType: { type: String, default: "minimal" },
    subContentStr: { type: String, default: "" },
    loader: { type: Number, default: 0 },
    isPlus: { type: Boolean, default: true },
    info: { type: String, default: "" },
  },
};
</script>

<style scoped>
.metric-card :deep(.p-card-title) > div {
  font-weight: 600;
  letter-spacing: 0.01em;
}
</style>
